import * as React from "react";

const CancelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g
      stroke="#FC6161"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_790_2817)"
    >
      <path d="m9 9 6 6M15 9l-6 6M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18"></path>
    </g>
    <defs>
      <clipPath id="clip0_790_2817">
        <path fill="#fff" d="M24 0H0v24h24z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CancelIcon;
